import { css } from '@/styled-system/css';

export const labelStyles = css.raw({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
});

// A fieldset lifts its legend out of the content box, so the indicator has to sit inside it;
// ! outranks FieldSet's `> .c11n_legend { display: block }`.
export const legendWithIndicatorStyles = css.raw({
  display: 'flex!',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
});

// ! outranks FormField's `> * { grid-column: 1 / -1 }`, which would drop the indicator below the label.
export const labelRowIndicatorStyles = css.raw({
  gridArea: 'tooltip!',
  justifySelf: 'end',
  alignSelf: 'center',
});
